const yellow = {
  95: '#fff7e5',
  90: '#ffefcc',
  80: '#ffde99',
  70: '#ffcf66',
  60: '#ffbe33',
  50: '#ffae00',
  45: '#e59d00',
  35: '#b27a00',
  25: '#805700',
  15: '#4d3400',
};

export default yellow;
